<template>
    <div id="container" :class="`route-type-${routeType}`">
        <Header/>
        <div class="working-with-us-label" >
            <span>WORKING WITH US</span>
        </div>
        <div id="smooth-wrapper">
            <div id="smooth-content">
                <div id="main">
                    <router-view :key="$route.fullPath"></router-view>
                </div>
                <Footer/>
            </div>
        </div>
        <Popup/>
        <FilterSidebar/>
        <FilterDepartmentSidebar/>
        <!--<DownArrow/>-->
        <TransitionOverlay></TransitionOverlay>
    </div>
</template>

<script>
import Header from './components/framework/Header'
import Footer from './components/framework/Footer'
import Popup from './components/framework/Popup'
import FilterSidebar from './components/framework/FilterSidebar'
import FilterDepartmentSidebar from './components/framework/FilterDepartmentSidebar'
//import DownArrow from './components/framework/DownArrow'
import TransitionOverlay from './components/framework/TransitionOverlay'
import { isMobile, browserName, osName } from 'mobile-device-detect'

import gsap from '@/plugins/gsap';
import ScrollTrigger from '@/plugins/gsap/ScrollTrigger';
import ScrollSmoother from '@/plugins/gsap/ScrollSmoother';
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
export default {
    name: 'App',
    components: {
        Header,
        Footer,
        //DownArrow,
        Popup,
        FilterSidebar,
        FilterDepartmentSidebar,
        TransitionOverlay
    },
    data() {
        return {
            window: window,
            document: document,
            showBlocker: false,
            routeType: '',
            vhOnce: true,
        }
    },
    watch: {
        $route(to) {
            this.routeType = to.meta.type || '';
        }
    },
    mounted() {
        this.routeType = this.$route.meta.type || '';

        let bname = String(browserName).toLowerCase()
        bname = bname.replace('mobile', '')
        bname = bname.replace(' ', '')
        this.document.body.className += ' browser-' + bname

        let osname = String(osName).toLowerCase()
        this.document.body.className += ' browser-os-' + osname

        if (isMobile) {
            this.document.body.className += ' device-mobile'
        } else {
            this.document.body.className += ' device-notmobile'
        }

        // Listen to window resize event
        this.window.addEventListener('resize', this.resize)
        this.resize()

        // Listen to window scroll event
        this.window.addEventListener('scroll', this.handleScroll)
        // Run it once on mount in case the page is not at the top
        this.handleScroll()

        if (isMobile) {
            this.window.addEventListener('orientationchange', this.siteOrientationChange)
            this.siteOrientationChange()
        }

        if (!isMobile) {
            this.smoother = ScrollSmoother.create({
                wrapper: '#smooth-wrapper',
                content: '#smooth-content',
                smooth: 1.2,
                effects: true,
            });

            this.smoother.effects('.working-with-us-label', { speed: 0, lag: false });
        }
    },
    beforeUnmount() {
        // Clean up event listeners
        this.window.removeEventListener('resize', this.resize)
        this.window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        resize() {
            // First we get the viewport height and multiply it by 1% to get a value for a vh unit
            let doIt = true
            if (this.vhOnce && isMobile) {
                doIt = false
            }
            if (doIt) {
                this.vhOnce = true
                let vh = this.window.innerHeight * 0.01;
                this.document.documentElement.style.setProperty('--vh', `${vh}px`)
            }
        },
        handleScroll() {
            if (this.window.scrollY > 0) {
                if (!this.document.body.classList.contains('is-scrolled')) {
                    this.document.body.classList.add('is-scrolled')
                }
            } else {
                this.document.body.classList.remove('is-scrolled')
            }
        },
        siteOrientationChange() {
            if (isMobile) {
                this.vhOnce = false
                this.resize()
                this.vhOnce = false
                setTimeout(this.resize, 100)
                // let t = this
                // setTimeout(function () {
                //     t.showBlocker = (t.window.innerWidth > t.window.innerHeight)
                // }.bind(t), 100)
            }
        },
    }
}
</script>

<style lang="scss">
@import "./assets/scss/app.scss";
</style>
